<template>
  <AppLayout class="documents-page-template">
      <DocumentsComponent/>
  </AppLayout>
</template>

<script>
import DocumentsComponent from '@/components/DocumentsComponent'
export default {
    components:{DocumentsComponent}
}
</script>

<style>

</style>
